import React, { useState, useEffect, useMemo, useRef } from 'react';
import './Home.css';
import profileImage from '../images/aby.png';

import cert2 from '../images/aby exp.jpg';
import cert3 from '../images/abycir.jpg';
import cert4 from '../images/abyste.png';
import project1Image1 from '../images/project1Image1.png';
import project1Image2 from '../images/2.png';
import project1Image3 from '../images/3.png';
import project1Image4 from '../images/4.png';
import project1Image5 from '../images/5.png';
import project1Image6 from '../images/6.png';
import project1Image7 from '../images/7.png';
import project1Image8 from '../images/8.png';
import project1Image9 from '../images/9.png';
import project1Image10 from '../images/Screenshot_20251030-093126.Chrome.jpg';
import project1Image11 from '../images/Screenshot (140).png';
import project1Image12 from '../images/Screenshot (134).png';

/* ─── data ─── */
const projects = [
  { title: 'Crystal Builders', desc: 'Modern construction company web app built with React.js — responsive, polished, and user-friendly.', image: project1Image11, year: '2025', tags: ['React', 'MERN'], live: 'https://test-five-steel-23.vercel.app/', code: 'https://github.com/Abincleetus007/test' },
  { title: 'River View Backwater Escapes', desc: 'Kayaking experience platform with engaging UI, destination listings, and booking exploration.', image: project1Image12, year: '2025', tags: ['React', 'UI/UX'], live: 'https://kayaking.vercel.app/', code: 'https://github.com/Abincleetus007/kayaking' },
  { title: 'HireLoop', desc: 'Vehicle management and booking app — browse, compare, and reserve vehicles seamlessly.', image: project1Image10, year: '2025', tags: ['MERN', 'Booking'], live: 'https://drive-gamma-ten.vercel.app/', code: 'https://github.com/Abincleetus007/drive' },
  { title: 'BookABed', desc: 'Accommodation booking platform with room browsing, detail views, and seamless reservation flow.', image: project1Image9, year: '2025', tags: ['MERN', 'Full-Stack'], live: 'https://frontend-eight-xi-77.vercel.app/', code: 'https://github.com/Abincleetus007/frontend' },
  { title: 'Food Delivery Website', desc: 'Full-stack food delivery app with cart, authentication, and secure payment integration.', image: project1Image8, year: '2024', tags: ['MERN', 'Payment'], live: 'https://foodie-hub-website.netlify.app/', code: 'https://github.com/Abincleetus007/Food_delivery_app' },
  { title: 'Rolex Watches', desc: 'Luxury watch landing page crafted in pure HTML & CSS — elegant, polished, sophisticated.', image: project1Image1, year: '2024', tags: ['HTML', 'CSS'], live: 'https://abincleetus007.github.io/rolex_watches-html-css-/', code: 'https://github.com/Abincleetus007/rolex_watches-html-css-' },
  { title: 'Calculator', desc: 'Simple yet elegant calculator with clean modern interface built in vanilla JS.', image: project1Image2, year: '2023', tags: ['JavaScript', 'HTML/CSS'], live: 'https://abincleetus007.github.io/Calculator-using-html-css-js-/', code: 'https://github.com/Abincleetus007/Calculator-using-html-css-js-' },
  { title: 'Fishy', desc: 'Aquatic-themed product store landing page with fun, playful design in HTML, CSS, JS.', image: project1Image3, year: '2023', tags: ['JavaScript', 'HTML/CSS'], live: 'https://abincleetus007.github.io/fishy/', code: 'https://github.com/Abincleetus007/fishy' },
  { title: "PIZZA's Pizzeria", desc: 'Online pizza ordering platform with menu browsing, customization, and cart flow.', image: project1Image4, year: '2024', tags: ['React', 'E-commerce'], live: 'https://capable-scone-1c7587.netlify.app/', code: 'https://github.com/Abincleetus007/React-project' },
  { title: 'Netflix Clone', desc: 'Netflix-inspired streaming UI integrated with TMDb API — browse and explore movies & shows.', image: project1Image5, year: '2024', tags: ['React', 'API'], live: 'https://net-flix-743829.netlify.app/', code: 'https://github.com/Abincleetus007/Netflix-Clone' },
  { title: 'Blog Application', desc: 'Full-stack CRUD blog app — write, edit, and share articles with a seamless user interface.', image: project1Image6, year: '2024', tags: ['MERN', 'Full-Stack'], live: 'https://incomparable-panda-e6d6cc.netlify.app/', code: 'https://github.com/Abincleetus007/blog_app' },
  { title: 'My Portfolio', desc: 'This very portfolio — built with React and themed around modern minimal design principles.', image: project1Image7, year: '2025', tags: ['React', 'Portfolio'], live: 'https://portfolio-xt52.vercel.app/', code: 'https://github.com/Abincleetus007/Portfolio' },
];

const certifications = [
  { id: 1, title: 'Computer Engineering', issuer: 'State Board of Technical Education', date: 'Dec 2025', category: 'Engineering',  skills: ['Computer Engineering'] },
  { id: 2, title: 'MERN Stack Experience Certificate', issuer: 'TechMaghi', date: 'Jan 2025', category: 'Full-Stack', image: cert2, skills: ['Frontend', 'Backend', 'Database'] },
  { id: 3, title: 'MERN Stack Developer Certification', issuer: 'TechMaghi', date: 'Feb 2025', category: 'Development', image: cert3, skills: ['MongoDB', 'React', 'Express.js', 'Node.js', 'JavaScript'] },
  { id: 4, title: 'STEM Certificate', issuer: 'STEM.org', date: 'Feb 2025', category: 'Technology', image: cert4, skills: ['Blockchain Security'] },
];

const skills = [
  { name: 'HTML5', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg' },
  { name: 'CSS3', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg' },
  { name: 'JavaScript', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg' },
  { name: 'React', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg' },
  { name: 'Node.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg' },
  { name: 'Express.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg' },
  { name: 'MongoDB', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg' },
  { name: 'GitHub', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg' },
];


/* ─────────────────────────────────────────
   WorkCard — zunedaalim.com style expanded card
   ───────────────────────────────────────── */
const WorkCard = ({ project: p, index: i }) => {
  return (
    <div className="work-card rv" id={`work-card-${i}`}>
      {/* Left: huge sticky number */}
      <div className="work-card__num-col">
        <span className="work-card__num">{i + 1 < 10 ? `Θ${i + 1}` : i + 1}</span>
      </div>

      {/* Right: details FIRST, then image below */}
      <div className="work-card__content-col">
        <div className="work-card__top">
          <div className="work-card__info">
            <h3 className="work-card__title">{p.title}</h3>
            <p className="work-card__subtitle">{p.desc}</p>
            <div className="work-card__tags">
              {p.tags.map((t, j) => <span key={j} className="z-tag">{t}</span>)}
              <span className="z-tag">{p.year}</span>
            </div>
          </div>
        </div>

        <div className="work-card__image-wrap">
          <a href={p.live} target="_blank" rel="noopener noreferrer" className="work-card__image-link">
            <div className="work-card__hover-view">View</div>
            <img src={p.image} alt={p.title} loading="lazy" className="work-card__img" />
          </a>
        </div>
      </div>
    </div>
  );
};

/* ─── component ─── */
const Home = () => {
  /* typing animation */
  const roles = useMemo(() => ['MERN Stack Developer', 'Full Stack Developer', 'Web Developer', 'React Developer'], []);
  const [typed, setTyped] = useState('');
  const [roleIdx, setRoleIdx] = useState(0);
  const [charIdx, setCharIdx] = useState(0);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    const speed = deleting ? 50 : 100;
    const pause = 2000;
    const full = roles[roleIdx];
    const t = setTimeout(() => {
      if (!deleting && charIdx < full.length) {
        setTyped(full.slice(0, charIdx + 1)); setCharIdx(c => c + 1);
      } else if (deleting && charIdx > 0) {
        setTyped(full.slice(0, charIdx - 1)); setCharIdx(c => c - 1);
      } else if (!deleting && charIdx === full.length) {
        setTimeout(() => setDeleting(true), pause);
      } else if (deleting && charIdx === 0) {
        setDeleting(false); setRoleIdx(i => (i + 1) % roles.length);
      }
    }, speed);
    return () => clearTimeout(t);
  }, [charIdx, deleting, roleIdx, roles]);

  /* show-more & modal — declared BEFORE the observer useEffect */
  const [showAll, setShowAll] = useState(false);
  const [certModal, setCertModal] = useState(null);
  const openCert = img => { setCertModal(img); document.body.style.overflow = 'hidden'; };
  const closeCert = () => { setCertModal(null); document.body.style.overflow = ''; };
  const handleShowAll = () => setShowAll(v => !v);
  const visibleProjects = showAll ? projects : projects.slice(0, 6);

  /* scroll-reveal — re-runs when showAll changes to catch new cards */
  const pageRef = useRef(null);
  const setupObserver = () => {
    const obs = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in-view'); obs.unobserve(e.target); } }),
      { threshold: 0.08 }
    );
    setTimeout(() => {
      const els = document.querySelectorAll('.rv:not(.in-view)');
      els.forEach(el => obs.observe(el));
    }, 40);
    return obs;
  };
  useEffect(() => {
    const obs = setupObserver();
    return () => obs.disconnect();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAll]);

  return (
    <div className="page" ref={pageRef}>

      {/* ══════════════════════════════════
          §1  HERO
      ══════════════════════════════════ */}
      <section id="home" className="hero">
        <div className="hero__watermark" aria-hidden="true">PORTFOLIO</div>

        {/* 3 Floating Animated Elements */}
        <div className="floating-shape shape-1" />
        <div className="floating-shape shape-2" />
        <div className="floating-shape shape-3" />

        <div className="hero__left">
          <p className="badge rv"> ✦</p>
          <h1 className="hero__name">
            <span className="rv rv-d1">ABIN</span>
            <span className="rv rv-d2">CLEETUS</span>
          </h1>
          <div className="hero__role rv rv-d3">
            <span className="typed">{typed}</span><span className="cursor">|</span>
          </div>
          <p className="hero__desc rv rv-d4">
            Crafting exceptional digital experiences with passion &amp; precision.
            Specializing in MERN stack development.
          </p>
          <div className="hero__ctas rv rv-d4">
            <button id="hero-contact" className="btn btn-dark" onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}>
              CONTACT ↗
            </button>
            <button id="hero-works" className="btn btn-outline" onClick={() => document.getElementById('works').scrollIntoView({ behavior: 'smooth' })}>
              VIEW WORK
            </button>
          </div>
        </div>

        <div className="hero__right rv rv-d2">
          <div className="hero__img-tag">
            <span>MERN STACK</span>
            <span>DEVELOPER</span>
          </div>
          <img src={profileImage} alt="Abin Cleetus" className="hero__img" />
        </div>

        <div className="hero__scroll">
          <div className="hero__scroll-line" />
          <span>SCROLL</span>
        </div>
      </section>

      {/* ══════════════════════════════════
          §2  ABOUT
      ══════════════════════════════════ */}
      <section id="about" className="about sec-dark">
        <div className="inner">
          <div className="sec-header rv">
            <span className="sec-label">ABOUT /</span>
            <span className="sec-num">(01)</span>
          </div>
          <div className="about__grid">
            <h2 className="about__title rv">
              Passionate developer<br />building the web.
            </h2>
            <div className="about__body rv rv-d1">
              <p>
                I am a passionate <strong>MERN Stack Developer</strong> who loves creating dynamic and
                scalable web applications. With a problem‑solving mindset and a focus on clean,
                efficient code, I continuously explore new technologies to build better solutions.
              </p>
              <p>
                My expertise lies in <strong>MongoDB, Express.js, React.js, and Node.js</strong>.
                I specialize in responsive interfaces and robust backends that deliver exceptional
                digital experiences.
              </p>
              <div className="pill-row">
                <a id="about-gh" href="https://github.com/Abincleetus007" target="_blank" rel="noopener noreferrer" className="pill">GitHub ↗</a>
                <a id="about-li" href="https://www.linkedin.com/in/abin-cleetus-1b9143277/" target="_blank" rel="noopener noreferrer" className="pill">LinkedIn ↗</a>
                <a id="about-mail" href="mailto:abincletus007@gmail.com" className="pill">Email ↗</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════
          §3  SKILLS
      ══════════════════════════════════ */}
      <section id="skills" className="skills sec-light">
        <div className="inner">
          <div className="sec-header rv">
            <span className="sec-label">SKILLS /</span>
            <span className="sec-num">(02)</span>
          </div>
          <h2 className="section-title rv">What I work with.</h2>
          <div className="skills__grid">
            {skills.map((s, i) => (
              <div key={i} className="skill-card rv" style={{ transitionDelay: `${i * 0.07}s` }}>
                <div className="skill-card__icon-box">
                  <img src={s.icon} alt={s.name} />
                </div>
                <p>{s.name}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════
          §4  WORKS
      ══════════════════════════════════ */}
      <section id="works" className="works sec-dark">
        <div className="inner works-inner">
          <div className="z-works-header rv">
            <h2 className="z-works-title">SELECTED WORKS /</h2>
            <div className="z-works-header-right">
              <span className="z-works-label">(PROJECTS)</span>
              <p className="z-works-desc">
                Thoughtfully crafted digital<br />
                experiences that blend utility<br />
                and aesthetics into something<br />
                functional, memorable, and refined.
              </p>
            </div>
          </div>

          <div className="works__list">
            {visibleProjects.map((p, i) => (
              <WorkCard key={i} project={p} index={i} />
            ))}
          </div>

          {projects.length > 6 && (
            <div className="works__more">
              <button
                id="show-more-btn"
                className="btn btn-light btn-light-outline"
                onClick={handleShowAll}
              >
                {showAll ? 'SHOW LESS ↑' : `SHOW ALL ${projects.length} PROJECTS ↓`}
              </button>
            </div>
          )}
        </div>
      </section>

      {/* ══════════════════════════════════
          §5  CERTIFICATIONS
      ══════════════════════════════════ */}
      <section id="certifications" className="certs sec-dark">
        <div className="inner">
          <div className="sec-header rv">
            <span className="sec-label sec-label--light">CERTIFICATIONS /</span>
            <span className="sec-num sec-num--light">(04)</span>
          </div>
          <h2 className="section-title section-title--light rv">Continuous Learning.</h2>

          <div className="certs__grid">
            {certifications.map((c, i) => (
              <div key={c.id} className="cert-card rv" style={{ transitionDelay: `${i * 0.1}s` }}>
                <div
                  className="cert-card__img-wrap"
                  onClick={() => openCert(c.image)}
                  id={`cert-${c.id}`}
                  role="button"
                  aria-label={`View ${c.title} certificate`}
                  tabIndex={0}
                  onKeyDown={e => e.key === 'Enter' && openCert(c.image)}
                >
                  <img src={c.image} alt={c.title} className="cert-card__img" loading="lazy" />
                  <div className="cert-card__zoom"><i className="fas fa-expand" /></div>
                </div>
                <div className="cert-card__body">
                  <div className="cert-card__meta">
                    <span className="cert-tag">{c.category}</span>
                    <span className="cert-date">{c.date}</span>
                  </div>
                  <h3 className="cert-title">{c.title}</h3>
                  <p className="cert-issuer"><i className="fas fa-award" /> {c.issuer}</p>
                  <div className="cert-skills">
                    {c.skills.map((s, j) => <span key={j} className="skill-chip">{s}</span>)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════
          §6  CONTACT / FOOTER
      ══════════════════════════════════ */}
      <footer id="contact" className="contact sec-dark">
        <div className="inner">
          <div className="sec-header rv">
            <span className="sec-label sec-label--light">CONTACT /</span>
            <span className="sec-num sec-num--light">(05)</span>
          </div>
          <h2 className="contact__title rv">
            Got a project<br />in mind?
          </h2>
          <div className="rv rv-d1">
            <a id="contact-email-btn" href="mailto:abincletus007@gmail.com" className="btn btn-light btn-lg">
              GET IN TOUCH ↗
            </a>
          </div>
          <div className="contact__socials rv rv-d2">
            <a id="footer-gh" href="https://github.com/Abincleetus007" target="_blank" rel="noopener noreferrer" className="contact__soc-link">GitHub</a>
            <span className="contact__dot">·</span>
            <a id="footer-li" href="https://www.linkedin.com/in/abin-cleetus-1b9143277/" target="_blank" rel="noopener noreferrer" className="contact__soc-link">LinkedIn</a>
            <span className="contact__dot">·</span>
            <a id="footer-mail" href="mailto:abincletus007@gmail.com" className="contact__soc-link">Email</a>
          </div>
          <div className="contact__bottom rv rv-d3">
            <p>© 2025 Abin Cleetus. All rights reserved.</p>
            <p>Designed &amp; Developed with passion.</p>
          </div>
        </div>
      </footer>

      {/* ── Cert Modal ── */}
      {certModal && (
        <div className="modal-backdrop" onClick={closeCert} id="cert-modal-backdrop">
          <div className="modal-box" onClick={e => e.stopPropagation()}>
            <button id="cert-modal-close" className="modal-close" onClick={closeCert} aria-label="Close">✕</button>
            <img src={certModal} alt="Certificate" className="modal-img" />
          </div>
        </div>
      )}

    </div>
  );
};

export default Home;
